interface AddInventoryItemQuantity {
    quantity_to_add?: number;
}

interface SetInventoryItemQuantity {
    quantity_to_set?: number;
}

type UpdateInventoryQuantity = {
    item_id: string;
    user_id: string;
} & (SetInventoryItemQuantity | AddInventoryItemQuantity);

class InventoryDataCaller {
    private baseUrl: string;
    private token: string;

    constructor(baseUrl: string, token: string) {
        this.baseUrl = baseUrl;
        this.token = token;
    }

    // async create(data: any): Promise<any> {
    //     const response = await fetch(`${this.baseUrl}`, {
    //         method: 'POST',
    //         headers: {
    //             'Content-Type': 'application/json',
    //             Authorization: `Bearer ${this.token}`,
    //         },
    //         body: JSON.stringify(data),
    //     });
    //     return response;
    // }

    async getProduct(license: string, id: string): Promise<any> {
        const response = await fetch(
            `${this.baseUrl}/product?license=${license}&product_id=${id}`,
            {
                headers: {
                    Authorization: `Bearer ${this.token}`,
                },
            },
        );
        return response;
    }

    async getAllProducts(license: string): Promise<any> {
        const response = await fetch(`${this.baseUrl}/product?license=${license}`, {
            headers: {
                Authorization: `Bearer ${this.token}`,
            },
        });
        return response;
    }

    async getItem(id: string): Promise<Response> {
        const response = await fetch(`${this.baseUrl}/item?item_id=${id}`, {
            headers: {
                Authorization: `Bearer ${this.token}`,
            },
        });
        return response;
    }

    // TODO: Figure out if there's a way to get all items for a given license without owners
    async getAllItems(ownerIDs: string[]): Promise<any> {
        const response = await Promise.allSettled(
            ownerIDs.map((owner) =>
                fetch(`${this.baseUrl}/item?item_owner=${owner}`, {
                    headers: {
                        Authorization: `Bearer ${this.token}`,
                    },
                }),
            ),
        );
        const respMap = response.map(async (resp) => {
            if (resp.status !== 'fulfilled') {
                return [];
            }
            const json = await resp.value.json();
            return json.data;
        });
        const awaitedRespMap = await Promise.all(respMap);
        return awaitedRespMap.flat(1);
    }

    async getInventory(
        userID: string,
        specific_item?: { itemId: string; itemType: string },
    ): Promise<Response> {
        const url =
            `${this.baseUrl}/inventory?user_id=${userID}` +
            (specific_item
                ? `&item_id=${specific_item.itemId}&item_type=${specific_item.itemType}`
                : '');
        console.log(url);
        const response = await fetch(url, {
            headers: {
                Authorization: `Bearer ${this.token}`,
            },
        });
        return response;
    }

    async getRecords(userID: string, start: Date, end: Date): Promise<any> {
        const response = await fetch(
            `${
                this.baseUrl
            }/record?user_id=${userID}&record_start=${start.valueOf()}&record_end=${end.valueOf()}`,
            {
                headers: {
                    Authorization: `Bearer ${this.token}`,
                },
            },
        );
        return response;
    }

    async updateProduct(data: any): Promise<any> {
        const response = await fetch(`${this.baseUrl}/product`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                Authorization: `Bearer ${this.token}`,
            },
            body: JSON.stringify({
                product: data,
            }),
        });
        return response;
    }

    async updateItem(data: any): Promise<any> {
        const response = await fetch(`${this.baseUrl}/item`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                Authorization: `Bearer ${this.token}`,
            },
            body: JSON.stringify({
                item: data,
            }),
        });
        return response;
    }

    async updateInventory(data: UpdateInventoryQuantity[]): Promise<Response> {
        const response = await fetch(`${this.baseUrl}/inventory/update/quantity`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                Authorization: `Bearer ${this.token}`,
            },
            body: JSON.stringify({
                inventory: data,
            }),
        });
        return response;
    }

    // TODO: Implement delete product/item/inventory
    // async delete(id: string): Promise<any> {
    //     const response = await fetch(`${this.baseUrl}/${id}`, {
    //         method: 'DELETE',
    //         headers: {
    //             Authorization: `Bearer ${this.token}`,
    //         },
    //     });
    //     return response;
    // }
}

export default InventoryDataCaller;
